import type { ShapeEditorProps } from './doc-context.js';
import { arr, ListEditor, Num, num, obj, patch, vec, Vec } from './fields.js';

/** `blob`: metaballs smoothly merged into one surface. */
export function BlobEditor({ shape, onChange }: ShapeEditorProps) {
  const set = (key: string, v: unknown) => onChange(patch(shape, key, v));
  return (
    <>
      <ListEditor
        title="Balls"
        hint="Spheres smooth-min blended into one surface."
        items={arr<unknown>(shape.balls).map((b) => obj(b) ?? {})}
        onChange={(v) => set('balls', v)}
        make={() => ({ center: [0, 0, 0], radius: 0.3 })}
        addLabel="Add ball"
        open
        itemTitle={(b, i) => `Ball ${i + 1} · r ${num(b.radius) ?? 0.5}`}
        render={(b, setB) => (
          <>
            <Vec label="Center" hint="Ball center (part space, m)." value={vec(b.center, 3)} onChange={(v) => setB(patch(b, 'center', v))} />
            <Num label="Radius" hint="Ball radius (m)." min={0} value={num(b.radius)} fallback={0.5} onChange={(v) => setB(patch(b, 'radius', v))} />
          </>
        )}
      />
      <Num label="Resolution" hint="Grid cells along the longest side." integer min={8} step={4} value={num(shape.resolution)} fallback={32} onChange={(v) => set('resolution', v)} />
      <Num label="Smoothness" hint="Smooth-min blend distance between balls." min={0} step={0.01} value={num(shape.smoothness)} fallback={0.2} onChange={(v) => set('smoothness', v)} />
    </>
  );
}
